import de from './de.json'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import id from './id.json'
import it from './it.json'
import zh from './zh.json'
import fa from './fa.json'

export default {
  messages: {
    de: de,
    en: en,
    es: es,
    fr: fr,
    id: id,
    it: it,
    zh: zh,
    fa: fa
  }
}